import React from 'react';
import type { Moment } from 'moment';
import { SearchArea, SearchBlock, SearchLabel } from '../../../search_area';
import DateRangePicker from '../../../date_range_picker';

interface Props {
  receiveDateFrom?: Moment;
  receiveDateTo?: Moment;
  suppliedItemName?: string;
  setReceiveDateFrom: (receiveDateFrom?: Moment) => void;
  setReceiveDateTo: (receiveDateTo?: Moment) => void;
}

const TotalSearchArea: React.FC<Props> = ({
  receiveDateFrom,
  receiveDateTo,
  suppliedItemName,
  setReceiveDateFrom,
  setReceiveDateTo
}) => {
  return (
    <SearchArea>
      <SearchBlock>
        <SearchLabel>予約日</SearchLabel>
        <DateRangePicker
          from={receiveDateFrom}
          to={receiveDateTo}
          onFromChange={d => setReceiveDateFrom(d)}
          onToChange={d => setReceiveDateTo(d)}
        />
      </SearchBlock>
      {suppliedItemName && (
        <SearchBlock>
          <SearchLabel>仕入商品</SearchLabel>
          <p>{suppliedItemName}</p>
        </SearchBlock>
      )}
    </SearchArea>
  );
};

export default TotalSearchArea;
